import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createPortfolio,
  getPortfolio,
  listPortfolios,
  listPositions,
  type NewPortfolioInput,
} from "./api";

export const usePortfolios = () => useQuery({ queryKey: ["portfolios"], queryFn: listPortfolios });

export const usePortfolio = (id: string | undefined) =>
  useQuery({
    queryKey: ["portfolios", id],
    queryFn: () => getPortfolio(id as string),
    enabled: !!id,
  });

export const usePositions = (portfolioId: string | undefined) =>
  useQuery({
    queryKey: ["positions", portfolioId],
    queryFn: () => listPositions(portfolioId as string),
    enabled: !!portfolioId,
  });

export function useCreatePortfolio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: NewPortfolioInput) => createPortfolio(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["portfolios"] }),
  });
}
